import React, { Component, useState, useReducer, useEffect, useRef } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Textarea from '../component/Textarea'
import TicketingCart from '../component/TicketingCart'
import MainLayout from '../mainLayout'
import TextField from './../component/TextField'
import Slider from "react-slick";
import Select from 'react-select';
//moment import
import moment from "moment";
//  Date Picker
import DatePicker from "react-datepicker";
import CalendarIcon from '../icons/calendaricon'
import Dropdown from '../component/Dropdown'
import CheckBox from '../component/CheckBox'
import VideoImageFile from '../component/VideoImageFile'
import VideoOnly from '../icons/VideoOnly'
import ImageText from '../icons/ImageText'
import TextOnlyIcon from '../icons/TextOnly'
// editor
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

// Images import
import PlusIcon from "../assets/images/plus_icon.svg";
import AddFileIcon from "./../icons/plusicon"
//Service import
import service from '../services'
import ErrorPopUp from '../component/errorPopUp'
import ModalMessage from '../component/ModalMessage'
import { Player, ControlBar, PlayToggle } from "video-react";
import CopyIcon from '../icons/copyicon'
import UploadVideo from '../component/UploadVideo'
import Loader from '../component/loader'
import VideoOnlyUpload from './VideoOnlyUpload'
import UploadForm from '../component/fpg/create/UploadForm'
import { sortedLastIndex } from 'lodash'
import PopUpCustomAll from '../component/fpg/create/popUpCustomAll'
import ImageOnlyUpload from './ImageOnlyUpload'
import commonImage from '../commonImage'
const initialState = { sliderData: [], fetching: false };
const reducer = (state, payload) => ({ ...state, ...payload });
let sub;
const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    customPaging: function (i) {
        return <div className="page_numb"> <h3>{`${i + 1}`}</h3></div>
    }
};

let videoIndex = 0
let imageIndex = 0


export default function Carousal() {
    const history = useHistory();
    const imgRef = useRef(null);
    const slider = useRef();
    const [apiserve, setApiserve] = useState(new service());
    const [{ sliderData }, setSliderData] = useReducer(reducer, initialState);
    const [headerSubtitle, setHeaderSubtitle] = useState(EditorState.createEmpty())
    const [editorState, setEditorState] = useState(EditorState.createEmpty())

    const [errorMsg, setErrorMsg] = useState('')
    const [errorPopup, setErrorPopup] = useState(false);
    const [filmDisabled, setFilmDisabled] = useState(false)
    const [showModel, setShowModel] = useState(false)
    const [checkBoxId, setCheckBoxId] = useState('')
    const [checkbox, setCheckBox] = useState('');
    const [loaderFlag, setLoaderFlag] = useState(false);
    const [videoPreLoader, setVideoPreLoader] = useState(false)
    const [imgFile, setImgFile] = useState(null);
    const [file, setFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [deleteImagePopup, setDeleteImagePopup] = useState(false)
    const [deleteVideoPopup, setDeleteVideoPopup] = useState(false)
    const [deleteVideoIndex, setDeleteVideoIndex] = useState(0)
    const [deleteImageIndex, setDeleteImageIndex] = useState(0)
    const [imagePreloader, setImagePreloader] = useState(false)
    const [imagePreloader2, setImagePreloader2] = useState(false)
    const [imagePreloader3, setImagePreloader3] = useState(false)
    const [messageModal, setMessageModal] = useState(false)
    const [showPreview, setShowPreview] = useState(null)
    const [options, setOptions] = useState(['Single Image Only', 'Three Images Horizontal', 'Three Images vertical']);
    const [dropimages, setDropImages] = useState('Single Image Only');
    const [index, setIndex] = useState();
    const [che, setche] = useState();
    const [validator, setValidator] = useState(new SimpleReactValidator({
        autoForceUpdate: this,
        validators: {
            urlValidation: {  // name the rule
                message: 'Please use a valid name of the :attribute',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                },
                required: false  // optional
            },
        }
    }))


    useEffect(() => {
        apiserve.sendevent("homePage|carousal|getList", {})
        eventCall();
        return () => {
            sub.unsubscribe();
        }
    }, [])
    useEffect(() => {
        const videoUp = () => {
            if (file.size > 100e6) {
                setErrorMsg("Please upload a video smaller than 100 MB");
                setErrorPopup(true);
                return false;
            }
            if (file.type === "video/mp4") {
                setTimeout(() => {


                    videoUpload(file, videoIndex);
                }, 1000);
            } else {
                setErrorMsg("Please upload only MP4 file");
                setErrorPopup(true);
            }
        }
        if (file) videoUp();
    }, [file])
    useEffect(() => {
        const imgUp = () => {
            const fileList = Math.round((imgFile.size / 1024));
            if (fileList >= 2048) {
                setErrorMsg('Please upload a file smaller than 2 MB')
                setErrorPopup(true)
                return false;
            }
            if (imgFile.type === 'image/png' || imgFile.type === 'image/jpg' || imgFile.type === 'image/jpeg' || imgFile.type === 'image/gif' || imgFile.type === 'image/jfif') {
                setTimeout(() => {
                    imageUploadOne(imgFile);
                }, 0)
            } else {
                setErrorMsg('Please upload a file for PNG,JPG or JPEG')
                setErrorPopup(true)
            }
        }
        if (imgFile) imgUp()
    }, [imgFile]);

    const eventCall = () => {
        sub = apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "homePage|carousal|getList":
                    if (!response.error) {
                        const data = [];
                        for (let i = 0; i < 5; i++) {
                            if (response.data.docs[i]) {
                                if (response.data.docs[i].styleType === "TextOnly") {
                                    let dataItem = response.data.docs[i]
                                    const blocksFromHtml = htmlToDraft(response.data.docs[i].sectionSubtitle);
                                    const { contentBlocks, entityMap } = blocksFromHtml;
                                    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                                    const editorState = EditorState.createWithContent(contentState);
                                    dataItem.value = true
                                    dataItem.editorState = editorState
                                    data.push(dataItem)
                                } else if (response.data.docs[i].styleType === "VideoOnly") {
                                    data.push(response.data.docs[i])
                                } else {
                                    let dataItem = response.data.docs[i]
                                    const blocksFromHtml = htmlToDraft(response.data.docs[i].sectionSubtitle);
                                    const { contentBlocks, entityMap } = blocksFromHtml;
                                    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                                    const editorState = EditorState.createWithContent(contentState);
                                    dataItem.editorState = editorState
                                    data.push(response.data.docs[i])
                                }
                                setShowPreview([0]);
                            } else {
                                data.push({
                                    _id: '',
                                    styleType: '',
                                    sectionTitle: "",
                                    sectionSubtitle: "",
                                    CTATitle: "",
                                    CTAUrl: "",
                                    formateType: "",
                                })
                            }
                        }
                        setSliderData({
                            sliderData: data
                        })
                    } else {
                        setErrorMsg(response.data.error)
                        setErrorPopup(true)
                    }
                    break;
                case "homePage|carousal|create":
                    if (!response.error) {

                        setLoaderFlag(false)
                        history.push("/home")
                    } else {
                        setErrorMsg(response.data.error)
                        setErrorPopup(true)
                    }
                    break;
                case "homePage|carousal|edit":
                    if (!response.error) {
                        setLoaderFlag(false)
                        apiserve.success('Updated successfully.')
                        history.push("/home")
                    } else {
                        setErrorMsg(response.data.error)
                        setErrorPopup(true)
                    }
                    break;
            }
        })
    }
    const onInputChange = (e, i) => {
        const sliderDataList = [...sliderData]
        const { name, value } = e.target
        sliderDataList[i][name] = value
        setSliderData({ sliderData: sliderDataList })
    }
    const Onchange = (e, id) => {
        setShowModel(true)
        setCheckBoxId(id)
        setCheckBox(e.target)
    }
    const confirmCheck = () => {
        const { name, checked, value } = checkbox;
        const sliderDataList = [...sliderData]
        const i = sliderDataList.findIndex(item => item._id === checkBoxId)
        if (i !== -1) {
            sliderDataList[i].value = checked
            sliderDataList[i].styleType = value
        }
        setSliderData({
            sliderData: sliderDataList,
        })
        setShowModel(false)
    }
    const cancle = () => {
        setShowModel(false)
    }
    const handleImage = (e, index, check) => {
        e.stopPropagation();
        e.preventDefault();

        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {

            imageIndex = index;
            setImgFile(file)
            const fileList = Math.round((file && file.size / 1024));
            if (fileList >= 2048) {
                setErrorPopup(true)
                setErrorMsg('Please upload a file smaller than 2 MB')
                return false;
            }
            if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                setTimeout(() => {
                    imageUploadOne(file, index, check,event.target.result);
                }, 0)
            } else {
                setErrorPopup(true)
                setErrorMsg('Please upload a file for PNG,JPG or JPEG')
            }
        }
    }

    const imageUploadOne = (file, index, check, img) => {
        if (check === "2") {
            setImagePreloader2(true)
            setImagePreloader3(false)
            setImagePreloader(false)
        } else if (check === "3") {
            setImagePreloader3(true)
            setImagePreloader2(false)
            setImagePreloader(false)
        } else {
            setImagePreloader(true)
            setImagePreloader3(false)
            setImagePreloader2(false)
        }

        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value)  => {
                if (index > -1) {
                    const sliderDataList = [...sliderData]
                    if (check === "2") {
                        sliderDataList[index].media[1].inSite = value
                    } else if (check === "3") {
                        sliderDataList[index].media[2].inSite = value
                    } else {
                        sliderDataList[index].media[0].inSite = value
                    }
                    setSliderData({ sliderData: sliderDataList, })
                    setImagePreloader(false)
                    setImagePreloader2(false)
                    setImagePreloader3(false)
                }
            });
    };

    const onEditorStateChange = (e, index) => {
        const slideInfo = [...sliderData];
        slideInfo[index].editorState = e;

        const name = slideInfo[index].editorState ? convertToRaw(slideInfo[index].editorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);
        slideInfo[index].sectionSubtitle = markup;
        setSliderData({ sliderData: slideInfo })
    }

    const submit = (e) => {
        if (validator.allValid()) {
            setLoaderFlag(true)
            let current_index = parseInt(slider.current.innerSlider.list.querySelector('.slick-current').getAttribute('data-index'))
            for (let i = 0; i < sliderData.length; i++) {
                if (sliderData[i].styleType === "VideoOnly") {
                    const data = {
                        styleType: sliderData[i].styleType,
                        videoUrl: sliderData[i].videoUrl || "",
                        video: sliderData[i].video || "",
                        sectionTitle: sliderData[i].sectionTitle || "",
                    }
                    if (sliderData[i]._id) data.id = sliderData[i]._id
                    else if (!(data.videoUrl || data.video || data.sectionTitle)) return;
                    // apiserve.sendevent(sliderData[i]._id ? "homePage|carousal|edit" : "homePage|carousal|create", data);
                    sliderData[i]._id ? current_index === i && apiserve.sendevent("homePage|carousal|edit", data) : apiserve.sendevent("homePage|carousal|create", data)
                }
                if (sliderData[i].styleType === "TextOnly") {
                    const data = {
                        styleType: sliderData[i].styleType,
                        sectionTitle: sliderData[i].sectionTitle || "",
                        sectionSubtitle: sliderData[i].sectionSubtitle || "",
                        CTATitle: sliderData[i].CTATitle || "",
                        CTAUrl: sliderData[i].CTAUrl || ""
                    }
                    if (sliderData[i]._id) data.id = sliderData[i]._id
                    else if (!(data.sectionSubtitle || data.CTATitle || data.CTAUrl || data.sectionTitle)) return;
                    // apiserve.sendevent(sliderData[i]._id ? "homePage|carousal|edit" : "homePage|carousal|create", data);
                    sliderData[i]._id ? current_index === i && apiserve.sendevent("homePage|carousal|edit", data) : apiserve.sendevent("homePage|carousal|create", data)
                }
                if (sliderData[i].styleType === "ImageAndText") {
                    const data = {
                        styleType: sliderData[i].styleType,
                        sectionTitle: sliderData[i].sectionTitle || "",
                        sectionSubtitle: sliderData[i].sectionSubtitle || "",
                        CTATitle: sliderData[i].CTATitle || "",
                        CTAUrl: sliderData[i].CTAUrl || "",
                        formateType: sliderData[i].formateType,
                        media: sliderData[i].media

                    }
                    if (sliderData[i]._id) data.id = sliderData[i]._id
                    else if (!(data.sectionSubtitle || data.CTATitle || data.CTAUrl || data.sectionTitle)) return;
                    // apiserve.sendevent(sliderData[i]._id ? "homePage|carousal|edit" : "homePage|carousal|create", data);
                    sliderData[i]._id ? current_index === i && apiserve.sendevent("homePage|carousal|edit", data) : apiserve.sendevent("homePage|carousal|create", data)
                }
            }
            // setShowModel(true)
        } else {
            setFilmDisabled(false);
            setMessageModal(true)
            validator.showMessages();
        }

    }
    const previewRecordTalk = (e) => {
        e.preventDefault()
        let data = [];
        if (validator.allValid()) {
            for (let i = 0; i < sliderData.length; i++) {
                if (sliderData[i].styleType === "VideoOnly") {
                    const data = {
                        styleType: sliderData[i].styleType,
                        videoUrl: sliderData[i].videoUrl || "",
                        video: sliderData[i].video || "",
                        sectionTitle: sliderData[i].sectionTitle || "",
                    }
                    if (sliderData[i]._id) data.id = sliderData[i]._id
                    else if (!(data.videoUrl || data.video || data.sectionTitle)) return;
                    apiserve.sendevent(sliderData[i]._id ? "homePage|carousal|edit" : "homePage|carousal|create", data);
                }
                if (sliderData[i].styleType === "TextOnly") {
                    const data = {
                        styleType: sliderData[i].styleType,
                        sectionTitle: sliderData[i].sectionTitle || "",
                        sectionSubtitle: sliderData[i].sectionSubtitle || "",
                        CTATitle: sliderData[i].CTATitle || "",
                        CTAUrl: sliderData[i].CTAUrl || ""
                    }
                    if (sliderData[i]._id) data.id = sliderData[i]._id
                    else if (!(data.sectionSubtitle || data.CTATitle || data.CTAUrl || data.sectionTitle)) return;
                    apiserve.sendevent(sliderData[i]._id ? "homePage|carousal|edit" : "homePage|carousal|create", data);
                }
                if (sliderData[i].styleType === "ImageAndText") {
                    const data = {
                        styleType: sliderData[i].styleType,
                        sectionTitle: sliderData[i].sectionTitle || "",
                        sectionSubtitle: sliderData[i].sectionSubtitle || "",
                        CTATitle: sliderData[i].CTATitle || "",
                        CTAUrl: sliderData[i].CTAUrl || "",
                        formateType: sliderData[i].formateType,
                        media: sliderData[i].media

                    }
                    if (sliderData[i]._id) data.id = sliderData[i]._id
                    else if (!(data.sectionSubtitle || data.CTATitle || data.CTAUrl || data.sectionTitle)) return;
                    apiserve.sendevent(sliderData[i]._id ? "homePage|carousal|edit" : "homePage|carousal|create", data);
                }
            }
            // setShowModel(true)
        }
        // for (let i = 0; i < sliderData.length; i++) {
        //     if (sliderData[i]._id) {
        //         if (sliderData[i].styleType === "VideoOnly") {
        //             data.push({
        //                 key: 'carousal',
        //                 id: sliderData[i]._id,
        //                 styleType: sliderData[i].styleType,
        //                 videoUrl: sliderData[i].videoUrl || "",
        //                 video: sliderData[i].video || "",
        //                 sectionTitle: sliderData[i].sectionTitle || ""
        //             })
        //         } else if (sliderData[i].styleType === "TextOnly") {
        //             data.push({
        //                 key: 'carousal',
        //                 id: sliderData[i]._id,
        //                 styleType: sliderData[i].styleType,
        //                 sectionTitle: sliderData[i].sectionTitle || "",
        //                 sectionSubtitle: sliderData[i].sectionSubtitle || "",
        //                 CTATitle: sliderData[i].CTATitle || "",
        //                 CTAUrl: sliderData[i].CTAUrl || "",
        //             })

        //         } else if (sliderData[i].styleType === "ImageAndText") {
        //             data.push({
        //                 key: 'carousal',
        //                 id: sliderData[i]._id,
        //                 styleType: sliderData[i].styleType,
        //                 imageUrl: sliderData[i].imageUrl || "",
        //                 image: sliderData[i].image || "",
        //                 sectionTitle: sliderData[i].sectionTitle || "",
        //                 sectionSubtitle: sliderData[i].sectionSubtitle || "",
        //                 CTATitle: sliderData[i].CTATitle || "",
        //                 CTAUrl: sliderData[i].CTAUrl || "",
        //                 formateType: sliderData[i].dropimages || "",
        //                 imageUrl2: sliderData[i].imageUrl2 || "",
        //                 image2: sliderData[i].image2 || "",
        //                 imageUrl3: sliderData[i].imageUrl3 || "",
        //                 image3: sliderData[i].image3 || "",
        //                 formateType: sliderData[i].formateType,
        //             })
        //         }
        //     }
        // }
        let carousalEvent = apiserve.encrypt(data)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_PREVIEW + 'carousel-preview?data=' + carousalEvent);
    }

    const cancelBTN = e => {
        e.preventDefault();
        window.location.reload();
        // this.props.history.push({pathaname: '/ticketing'})
    };

    const videoUpload = (file, i) => {
        setVideoPreLoader({ videoPreLoader: true })

        var fileSet = commonImage(file,false,'',fileUrl)
        fileSet.then((value) => {

                if (i > -1) {
                    setVideoPreLoader(false)
                    const sliderDataList = [...sliderData]
                    sliderDataList[i].video = value
                    setSliderData({ sliderData: sliderDataList, })
                }
            });
    };
    const closeAdminUser = () => {
        setDeleteVideoPopup(false)
        setDeleteImagePopup(false)
        setMessageModal(false);
    };


    //for delete video 
    const deleteVideo = (e, i) => {

        setDeleteVideoPopup(true)
        setDeleteVideoIndex(i)
    }
    const onDeleteVideoPopup = (e, id) => {

        const sliderDataList = [...sliderData]
        sliderDataList[deleteVideoIndex].video = '';
        setSliderData({ sliderData: sliderDataList, })
        setDeleteVideoPopup(false)
    }
    // textbox video change 
    const OnchangeVideo = (e, i) => {
        const { value } = e.target
        const sliderDataList = [...sliderData]
        sliderDataList[i].videoUrl = value
        setSliderData({ sliderData: sliderDataList })
    }

    // textbox Iamge change 
    const OnchangeImage = (e, i, check) => {
        const { value } = e.target
        const sliderDataList = [...sliderData]

        if (check === "2") {
            sliderDataList[i].media[1].link = value
        } else if (check === "3") {
            sliderDataList[i].media[2].link = value
        } else {
            sliderDataList[i].media[0].link = value
        }
        setSliderData({ sliderData: sliderDataList })
    }
    //for delete Image 
    const deleteImage = (e, i, check) => {
        setDeleteImagePopup(true)
        setDeleteImageIndex(i)
        setIndex(i)
        setche(check)
    }
    const onDeleteImagePopup = (e) => {
        const sliderDataList = [...sliderData]
        if (che === "2") {
            sliderDataList[index].media[1].inSite = ''
        } else if (che === "3") {
            sliderDataList[index].media[2].inSite = ''
        } else {
            sliderDataList[index].media[0].inSite = ''
        }
        setSliderData({ sliderData: sliderDataList })
        setDeleteImagePopup(false)

    }
    const onChangeFile = (e, index) => {
        e.stopPropagation();
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {

            videoIndex = index
            setFile(file)
            setFileUrl(event.target.result)
        };
    };

    const onChangeSponsor = (e, i) => {
        e.preventDefault();
        // const { name, value } = e.target;
        // setDropImages(value)
        const sliderDataList = [...sliderData]
        const { name, value } = e.target
        sliderDataList[i][name] = value
        setSliderData({ sliderData: sliderDataList })
    }

    return (
        <>
        <div className="select_style_wrap ">
            <Slider  {...settings} ref={slider}>
                {sliderData.map((item, index) => {
                    return (
                        <>
                        <div>
                            <div className="bg_white pt_10">
                                <div className="text_center select_title">
                                    <p className="uppercase">Select a style</p>
                                </div>
                                <div className="d_flex d_flex_align_center d_flex_justify_center">
                                    <div className="style_box">
                                        <VideoOnly />
                                        <CheckBox
                                            onChange={(e) => Onchange(e, item._id)}
                                            checked={item.styleType === "VideoOnly" && true}
                                            value="VideoOnly"
                                            type="checkbox" name="VideoOnly"
                                            label="Video Only"
                                            id={`videoonly` + index} />
                                    </div>
                                    <div className="style_box">
                                        <ImageText />
                                        <CheckBox
                                            onChange={(e) => Onchange(e, item._id)}
                                            checked={item.styleType === "ImageAndText" && true}
                                            value="ImageAndText"
                                            type="checkbox"
                                            name="ImageAndText"
                                            label="Image & Text"
                                            id={`imagetext` + index} />
                                    </div>
                                    <div className="style_box">
                                        <TextOnlyIcon />
                                        <CheckBox
                                            onChange={(e) => Onchange(e, item._id)}
                                            value="TextOnly"
                                            checked={item.styleType === "TextOnly" && true}
                                            type="checkbox" name="TextOnly"
                                            label="Text Only"
                                            id={`textonly` + index} />
                                    </div>
                                </div>
                            </div>

                            <div className="d_flex d_flex_justify_center mt_25 theme_bg pt_25">
                                {item.styleType === "VideoOnly" &&
                                    <>

                                    <div className="form_group_video loader-main">
                                        <div className="mb_25">
                                            <VideoOnlyUpload
                                                index={index}
                                                handleVideo={(e) => onChangeFile(e, index)}
                                                insideOnchange={(e) => OnchangeVideo(e, index)}
                                                url={item.video ? `${apiserve.imageUrl}${item.video}` : item.videoUrl}
                                                video={item.video ? `${apiserve.imageUrl}${item.video}` : item.videoUrl}
                                                videoUrl={item.videoUrl}
                                                item={item}
                                                iconDelete={true}
                                                showDeleteIcon={item.video}
                                                videoPreLoader={videoPreLoader} setErrorMsg={setErrorMsg} setErrorPopup={setErrorPopup}
                                                deleteVideo={(e) => deleteVideo(e, index)}
                                                uploadmessage="Upload mp4 of max size of 100MB"
                                            />
                                        </div>
                                    </div>



                                    <div className="home_text_select">
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="Section Title" value={item.sectionTitle} name="sectionTitle" onChange={(e) => onInputChange(e, index)} />
                                        </div>
                                    </div>
                                    </>
                                }
                                {item.styleType === "ImageAndText" &&
                                    <>
                                    <div className="mb_25 d_flex home_text_select d_flex_justify_center w_100">
                                        <div className="editor_400 field_row horizontal_field">
                                            <Dropdown name="formateType" label="Format Type" value={item.formateType} options={options} onChange={(e) => onInputChange(e, index)} />
                                        </div>
                                    </div>
                                    <div className={item.formateType === "Three Images Horizontal" ? `d_flex d_flex_justify_center` : ''}>
                                        {item.formateType === "Single Image Only" || item.formateType === 'Empty Format' ?
                                            <div className="file_upload_400 mb_25 mr_15">
                                                <div className="uploads_files">
                                                    <ImageOnlyUpload
                                                        item={item._id}
                                                        handleImage={(e) => handleImage(e, index)}
                                                        deleteImage={(e) => deleteImage(e, index)}
                                                        iconDelete={true}
                                                        showDeleteIcon={item ?.media[0] ?.inSite}
                                                        size="2"
                                                        id={item._id}
                                                        image={item ?.media[0] ?.link}
                                                        value={item ?.media[0] ?.inSite ? `${apiserve.imageUrl}${item ?.media[0] ?.inSite}` : item ?.media[0] ?.link}
                                                        ImagePreLoader={imagePreloader}
                                                        insideOnchange={(e) => OnchangeImage(e, index)}
                                                        isboth={false}

                                                    />
                                                </div>

                                            </div>
                                            :
                                            <>
                                            <div className="file_upload_400 mb_25 mr_15">
                                                <div className="uploads_files">
                                                    <ImageOnlyUpload
                                                        item={item._id}
                                                        handleImage={(e) => handleImage(e, index)}
                                                        deleteImage={(e) => deleteImage(e, index)}
                                                        iconDelete={true}
                                                        showDeleteIcon={item ?.media[0] ?.inSite}
                                                        size="2"
                                                        id={item._id}
                                                        image={item ?.media[0] ?.link}
                                                        value={item ?.media[0] ?.inSite ? `${apiserve.imageUrl}${item ?.media[0] ?.inSite}` : item ?.media[0] ?.link}
                                                        ImagePreLoader={imagePreloader}
                                                        insideOnchange={(e) => OnchangeImage(e, index)}
                                                        isboth={false}

                                                    />
                                                </div>

                                            </div>
                                            <div className="file_upload_400 mb_25 mr_15">
                                                <div className="uploads_files">
                                                    <ImageOnlyUpload
                                                        item={item._id}
                                                        handleImage={(e) => handleImage(e, index, "2")}
                                                        deleteImage={(e) => deleteImage(e, index, "2")}
                                                        iconDelete={true}
                                                        showDeleteIcon={item ?.media[1] ?.inSite}
                                                        size="2"
                                                        id={item._id}
                                                        image={item ?.media[1] ?.link}
                                                        value={item ?.media[1] ?.inSite ? `${apiserve.imageUrl}${item ?.media[1] ?.inSite}` : item ?.media[1] ?.link}
                                                        ImagePreLoader={imagePreloader2}
                                                        insideOnchange={(e) => OnchangeImage(e, index, "2")}
                                                        isboth={false}

                                                    />
                                                </div>

                                            </div>
                                            <div className="file_upload_400 mb_25 mr_15">
                                                <div className="uploads_files">
                                                    <ImageOnlyUpload
                                                        item={item._id}
                                                        handleImage={(e) => handleImage(e, index, "3")}
                                                        deleteImage={(e) => deleteImage(e, index, "3")}
                                                        iconDelete={true}
                                                        showDeleteIcon={item ?.media[2].inSite}
                                                        size="2"
                                                        id={item._id}
                                                        image={item ?.media[2].link}
                                                        value={item ?.media[2].inSite ? `${apiserve.imageUrl}${item ?.media[2].inSite}` : item ?.media[2].link}
                                                        ImagePreLoader={imagePreloader3}
                                                        insideOnchange={(e) => OnchangeImage(e, index, "3")}
                                                        isboth={false}

                                                    />
                                                </div>
                                            </div>
                                            </>
                                        }
                                    </div>

                                    <div className="home_text_select">
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="Section Title" value={item.sectionTitle} name="sectionTitle" onChange={(e) => onInputChange(e, index)} />
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label>Section Subtitle (Optional)</label>
                                                <div className="field_input editor_wrapper">
                                                    <Editor
                                                        wrapperClassName="sd_text_editor"
                                                        editorState={item.editorState}
                                                        onEditorStateChange={(e) => onEditorStateChange(e, index)}
                                                        toolbar={{
                                                            blockType: {
                                                                inDropdown: true,
                                                                options: ['Normal', 'Blockquote'],
                                                            },
                                                            inline: {
                                                                inDropdown: true,
                                                                options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                            },
                                                            list: {
                                                                inDropdown: true,
                                                                options: ['unordered', 'ordered'],
                                                            },
                                                            textAlign: { inDropdown: true },
                                                            link: { inDropdown: true },
                                                            history: { inDropdown: true },
                                                            options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                        }}
                                                        editorStyle={{ height: '250px' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="CTA Title" value={item.CTATitle} name="CTATitle" onChange={(e) => onInputChange(e, index)} />
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="CTA URL" value={item.CTAUrl} name="CTAUrl" onChange={(e) => onInputChange(e, index)} />
                                        </div>
                                        <span style={{ color: 'red' }}>{validator.message('cta URL', item.CTAUrl, 'urlValidation')}</span>

                                    </div>
                                    </>
                                }
                                {item.styleType === "TextOnly" ?

                                    <div className="home_text_select">
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="Section Title" name="sectionTitle" onChange={(e) => onInputChange(e, index)} value={item.sectionTitle} />
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label>Section Subtitle (Optional)</label>
                                                <div className="field_input editor_wrapper">
                                                    <Editor
                                                        wrapperClassName="sd_text_editor"
                                                        editorState={item.editorState}
                                                        onEditorStateChange={(e) => onEditorStateChange(e, index)}
                                                        toolbar={{
                                                            blockType: {
                                                                inDropdown: true,
                                                                options: ['Normal', 'Blockquote'],
                                                            },
                                                            inline: {
                                                                inDropdown: true,
                                                                options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                            },
                                                            list: {
                                                                inDropdown: true,
                                                                options: ['unordered', 'ordered'],
                                                            },
                                                            textAlign: { inDropdown: true },
                                                            link: { inDropdown: true },
                                                            history: { inDropdown: true },
                                                            options: ['inline', 'blockType', 'list', 'link', 'textAlign',],

                                                        }}
                                                        editorStyle={{ height: '250px' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="CTA Title" name="CTATitle" onChange={(e) => onInputChange(e, index)} value={item.CTATitle} />
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="CTA URL" name="CTAUrl" onChange={(e) => onInputChange(e, index)} value={item.CTAUrl} />
                                        </div>
                                        <span style={{ color: 'red' }}>{validator.message('cta URL', item.CTAUrl, 'urlValidation')}</span>
                                    </div>
                                    : ''
                                }
                            </div>
                        </div>
                        </>
                    )
                })}
            </Slider>
            <div className="text_center field_row w_100 buttons_outer mb_0">
                <button className="uppercase" onClick={(e) => cancelBTN(e) }>CANCEL</button>
                {showPreview && <button className="uppercase prev_btn" onClick={(e) => previewRecordTalk(e)}>PREVIEW</button>}
                <button className="uppercase active" onClick={(e) => submit(e)} type="button" disabled={loaderFlag}>SAVE</button>
            </div>
        </div>
        {loaderFlag ? <Loader /> : ''}
        {showModel &&
            <div className="user_popup active">
                <span className="popup_overlay" ></span>
                <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                    <div className="approve_popup_header text_center relative">
                        <p>Changing style of the current section will delete all its content. Do you want to proceed?</p>
                    </div>
                    <div className="content">
                        <div className="field_row text_center">
                            <button onClick={(e) => cancle(e)} >NO</button>
                            <button className="active" onClick={(e) => confirmCheck(e)}  >YES</button>
                        </div>
                    </div>
                </div>
            </div>
        }
        {deleteVideoPopup ? (
            <PopUpCustomAll
                HeaderName="Delete video?"
                insideDetails="Are You Sure ?"
                insideData="Are you sure you want to delete this video or image?"
                popupState={() => closeAdminUser()}
                yesPopUp={() => onDeleteVideoPopup()}
            />
        ) : (
                ""
            )}

        {deleteImagePopup ? (
            <PopUpCustomAll
                HeaderName="Delete Image?"
                insideDetails="Are You Sure ?"
                insideData="You want to delete this image"
                popupState={() => closeAdminUser()}
                yesPopUp={() => onDeleteImagePopup()}
            />
        ) : (
                ""
            )}
        {messageModal &&
            <ModalMessage messageModal={messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={closeAdminUser()} />
        }
        {errorMsg &&
            <ErrorPopUp
                errorMsg={errorMsg}
                errorMsgPopup={() => {
                    setErrorMsg("")
                    setErrorPopup(false)
                }}
            />}
        </>
    )
}